import React from 'react';

const getNotCompletedCompehension = (firstName, lastName) => (
    <h4 className="text-center assessment-title mt-4">
        {`${lastName}, ${firstName} has not completed comprehension for this story.`}
    </h4>
);

export default getNotCompletedCompehension;
